import { breadcrumbTrail } from "../../utils/navigation.js";
import { state } from "../../state/workspaceStore.js";
import { nodes } from "../common/reactHelpers.jsx";
import { esc } from "../../utils/format.js";
export function breadcrumbs() {
  const trail = breadcrumbTrail(
    state.current.route,
    state.current.id,
    state.db,
  );
  return (
    <nav className={"breadcrumbs"} aria-label={"Breadcrumb"}>
      <ol>
        {nodes(
          trail.map((c, i) => (
            <li>
              {i === trail.length - 1 ? (
                <span aria-current={"page"}>{esc(c.label)}</span>
              ) : c.route ? (
                <a
                  href={
                    "#" + c.route + (c.id ? "/" + encodeURIComponent(c.id) : "")
                  }
                >
                  {esc(c.label)}
                </a>
              ) : (
                <span>{esc(c.label)}</span>
              )}
            </li>
          )),
        )}
      </ol>
    </nav>
  );
}
